import { FileSignature } from "lucide-react";

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("de-CH", { dateStyle: "medium", timeStyle: "short" });
  } catch { return iso; }
};

export const StatusBadge = ({ status }) => {
  const map = {
    pending: { bg: "bg-amber-100", text: "text-amber-800", label: "Wartet" },
    approved: { bg: "bg-emerald-100", text: "text-emerald-800", label: "Freigeschaltet" },
    rejected: { bg: "bg-rose-100", text: "text-rose-800", label: "Abgelehnt" },
  };
  const m = map[status] || { bg: "bg-slate-100", text: "text-slate-700", label: status };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest font-bold ${m.bg} ${m.text}`}>
      {m.label}
    </span>
  );
};

export const ContractBadge = ({ contract }) => {
  const signed = !!contract?.signed_at;
  const waived = !signed && !!contract?.waived;
  let cls = "bg-rose-100 text-rose-800";
  let label = "Vertrag offen";
  let testid = "contract-badge-missing";
  if (signed) { cls = "bg-emerald-100 text-emerald-800"; label = "Vertrag ✓"; testid = "contract-badge-signed"; }
  else if (waived) { cls = "bg-sky-100 text-sky-800"; label = "Befreit"; testid = "contract-badge-waived"; }
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest font-bold ${cls}`}
      title={signed ? "Vertrag unterschrieben" : (waived ? "Vom Admin von der Vertragspflicht befreit" : "Vertrag noch nicht unterschrieben")}
    >
      <FileSignature className="h-2.5 w-2.5" /> {label}
    </span>
  );
};
